export const getInitConfig = () => {
  if (window.siteConfig) {
    return window.siteConfig
  } else {
    let domain = localStorage.getItem('loginType');
    let config = {
      loginBack: 'static/images/login/bg.jpg',
      loginText: 'SPARK管理后台',
      ico: 'static/images/favicon.ico',
      title: 'SPARK影像住培教学平台',
      showDownBtn: true,
      logoUrl: 'static/images/SPARK-LOGO.png',
      logoText: 'SPARK影像住培教学平台'
    };
    let xhr = new XMLHttpRequest();
    // xhr.open('GET', '/siteConfig/' + domain, false);
    xhr.open('GET', 'static/siteConfig/' + domain, false);
    xhr.send(null);
    if (xhr.status === 200) {
      try {
        let siteConfig = JSON.parse(xhr.responseText)
        if (siteConfig) {
          config = Object.assign(config, siteConfig)
        }
      } catch (error) {
        // console.log(error);
      }
    } else {}
    window.siteConfig = config;
    return config;
  }
};



// WEBPACK FOOTER //
// ./src/config/config.js